import React, { useEffect,  useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import ColourTable from "../../../../components/Tables/ColourTable";
import { FiMenu } from "react-icons/fi";
import {
  ColourFilter,
  ProdGrpMonthlyCon,
  ProdGrpMonthlyConFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const MasterWiseMonthlyConsumption = () => {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, ProdGrpMonthlyCondata } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  // 🔹 Offcanvas State
  const [showFilter, setShowFilter] = useState(false);

  // 🔹 Dummy Data
  const productionGroupList = ColourfilterData?.ProductionGroup?.map(
    (item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    }),
  );
  const [filter, setFilter] = useState({
    productionGroup: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
  });
  useEffect(() => {
    dispatch(ProdGrpMonthlyConFun());
    dispatch(
      ProdGrpMonthlyCon({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ProductionGroupMstIDs: (filter.productionGroup || []).join(","),
      }),
    );
  }, [filter.productionGroup, Firm, FinancialYear]);

  useEffect(() => {
    dispatch(ColourFilter());
  }, [dispatch]);

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];
      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const TableChartColumns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Production Group",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total", key: "Total", align: "right", format: "true" },
    { label: "Apr", key: "AprilConsAmt", align: "right", format: "true" },
    { label: "May", key: "MayConsAmt", align: "right", format: "true" },
    { label: "Jun", key: "JunConsAmt", align: "right", format: "true" },
    { label: "Jul", key: "JulyConsAmt", align: "right", format: "true" },
    { label: "Aug", key: "AugConsAmt", align: "right", format: "true" },
    { label: "Sep", key: "SepConsAmt", align: "right", format: "true" },
    { label: "Oct", key: "OctConsAmt", align: "right", format: "true" },
    { label: "Nov", key: "NovConsAmt", align: "right", format: "true" },
    { label: "Dec", key: "DecConsAmt", align: "right", format: "true" },
    { label: "Jan", key: "JanConsAmt", align: "right", format: "true" },
    { label: "Feb", key: "FebConsAmt", align: "right", format: "true" },
    { label: "Mar", key: "MarchConsAmt", align: "right", format: "true" },
  ];

  const TableChartRow = (ProdGrpMonthlyCondata?.Detail || [])?.map((row) => ({
    ProductionGroupMstName: row.ProductionGroupMstName || "",
    AprilConsAmt: row.AprilConsAmt || "",
    AugConsAmt: row.AugConsAmt || "",
    DecConsAmt: row.DecConsAmt || "",
    FebConsAmt: row.FebConsAmt || "",
    JanConsAmt: row.JanConsAmt || "",
    JulyConsAmt: row.JulyConsAmt || "",
    JunConsAmt: row.JunConsAmt || "",
    MarchConsAmt: row.MarchConsAmt || "",
    MayConsAmt: row.MayConsAmt || "",
    NovConsAmt: row.NovConsAmt || "",
    OctConsAmt: row.OctConsAmt || "",
    SepConsAmt: row.SepConsAmt || "",
    Total: row.Total || "",
  }));

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ProdGrpMonthlyCondata || ProdGrpMonthlyCondata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >


      <Row>
        {/* MOBILE FILTER BUTTON */}
        <div className="d-lg-none text-end mb-2">
          <Button
            onClick={() => setShowFilter(true)}
            style={{
              background:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
              border: "none",
            }}
          >
            <FiMenu />
          </Button>
        </div>

        {/* MOBILE OFFCANVAS */}
        <Offcanvas
          show={showFilter}
          onHide={() => setShowFilter(false)}
          placement="start"
          style={{
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ColourFilterBox
              title="Production Group"
              items={productionGroupList || []}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList || [])
              }
            />
          </Offcanvas.Body>
        </Offcanvas>

        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <ColourFilterBox
            title="Production Group"
            items={productionGroupList || []}
            search={search.productionGroup}
            setSearch={(val) => handleSearch("productionGroup", val)}
            selectedItems={filter.productionGroup}
            toggleItem={(item) => toggleItem("productionGroup", item)}
            selectAll={() =>
              selectAll("productionGroup", productionGroupList || [])
            }
          />
        </Col>

        {/* CONTENT */}
        <Col xl={9} lg={8}>
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MASTERWISE MONTHLY CONSUMPTION DETAIL
            </div>

            <ColourTable columns={TableChartColumns} data={TableChartRow} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MasterWiseMonthlyConsumption;
